import Button from "@components/atoms/Button";
import useGlobalModal from "@hooks/useGlobalModal";
import useGlobalNoti from "@hooks/useGlobalNoti";
import useTermsDataStore, { type CategoryInfoType } from "@store/terms";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { textFormat, upDataAtFormat } from "@utils/TableItemFormattingUtils";
import { type ColDef, type ICellRendererParams } from "ag-grid-community";
import { type CommonContentsRenderType, type CommonFilterDataType } from "src/types/common";
import React from "react";

const TermsDetailActionCell: React.FC<ICellRendererParams> = ({ value }) => {
    const categoryInfo = useTermsDataStore((state): CategoryInfoType => state.categoryInfo);
    const { showTermsEditorModal } = useGlobalModal();
    const { hideNoti } = useGlobalNoti();

    const handleTermsEditorOpenModal = () => {
        hideNoti();
        showTermsEditorModal({
            title: categoryInfo.title ?? "",
            termsUuid: value ?? "",
        });
    };

    return <Button buttonSize="small" buttonType="line_black" text="상세보기" style={{ padding: "8px" }} onClick={handleTermsEditorOpenModal} />;
};

export type TermsDetailInitialValues = {
    title: string;
    isRequired: string;
    isVisibleOnSignup: string;
    isVisibleOnServicePage: string;
    effectiveStartAt: string;
    effectiveEndAt: string;
    content: string;
    category: string;
};

export const TermsDetailData: CommonFilterDataType<TermsDetailInitialValues, CommonContentsRenderType, ColDef<any>> = {
    formInitialValues: {
        title: "",
        isRequired: "",
        isVisibleOnSignup: "",
        isVisibleOnServicePage: "",
        effectiveStartAt: "",
        effectiveEndAt: "",
        content: "",
        category: "",
    },

    forms: [
        {
            type: CommonElementType.INFO_INPUT,
            name: "title",
            label: "약관명",
        },
        {
            type: CommonElementType.INFO_INPUT,
            name: "isRequired",
            label: "필수 여부",
        },
        {
            type: CommonElementType.INFO_INPUT,
            name: "isVisibleOnSignup",
            label: "회원가입 노출",
        },
        {
            type: CommonElementType.INFO_INPUT,
            name: "isVisibleOnServicePage",
            label: "서비스 약관 노출",
        },
    ],
    tableList: [
        {
            field: "effectiveDataAt",
            headerName: "게시 기간",
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "createdAt",
            headerName: "등록 날짜",
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
        {
            field: "updatedBy",
            headerName: "마지막 수정",
            suppressMovable: true,
            flex: 1,
            cellRenderer: textFormat,
        },
        {
            field: "uuid",
            headerName: "관리",
            pinned: "right",
            suppressMovable: true,
            maxWidth: 100,
            cellRenderer: TermsDetailActionCell,
        },
    ],
};
